module.exports = __webpack_public_path__ + "static/media/blake.8ae61b0d.png";